import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[integerOnly]'
})
export class IntegerInputDirective {

  private regex: RegExp = new RegExp(/^[1-9]\d*$/); // 2 decimal places
  private specialKeys: string[] = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.includes(event.key)) {
      return;
    }

    const current = (event.target as HTMLInputElement).value;
    const next = current.concat(event.key);

    if (!String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}